import React, {Dispatch, SetStateAction} from 'react';
import {CustomTypography} from "../CustomTypography";
import {Button} from "@material-tailwind/react";
import {ChevronLeft, ChevronRight} from "@mui/icons-material";
import {CardFooter} from "reactstrap";
import {useTranslation} from "react-i18next";
import {SIZE_PAGINATION} from "../../../conf";
import ButtonsPagination from "./ButtonsPagination";

export type PaginationtableProps = {
    currentPage?: number;
    totalPages?: number;
    totalElements?: number;
    loading?: boolean;
    setIndex?: Dispatch<SetStateAction<number | undefined>>;
}

export default function Paginationtable({
                                            setIndex,
                                            currentPage,
                                            totalElements,
                                            totalPages,
                                            loading,
                                            }: PaginationtableProps) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    let pageLimit = SIZE_PAGINATION / 2; // número de enlaces de página en la paginación
    let start = 0; // starting page
    let end = pageLimit; // ending page

    if ((currentPage || currentPage === 0) && (totalPages || totalPages === 0) && (totalElements || totalElements === 0)) {
        if (totalPages! <= pageLimit) {
            pageLimit = totalPages!;
        }
        // incrementa la página de inicio cuando la página actual es mayor que 2
        if (currentPage! - 2 >= 0) {
            start = currentPage! - 1;
        }
        // si llega al final del incremento de parada de paginación
        if (start + pageLimit >= totalPages!) {
            start = totalPages! - pageLimit;
        }
        // incrementa la página final cuando el actual + 2 excede el límite de página
        if (currentPage! + 2 >= pageLimit) {
            end = currentPage! + 3;
            pageLimit = end;
            if (totalPages! <= pageLimit) {
                pageLimit = totalPages!;
            }
        }
    }

    function getCurrent() {
        if (currentPage || currentPage === 0) {
            return currentPage
        }
        return 0
    }

    return (
        <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-2">
            <CustomTypography
                variant="small"
                color="blue-gray"
                text={`${t('page')} ${currentPage !== undefined ? currentPage + 1 : '0'} - ${totalPages ? totalPages : '0'} ${t('of')} ${totalElements ? totalElements : '0'} ${t('records')}`}/>
            <div className="flex flex-col sm:flex-row gap-2">
                <Button
                    placeholder='button'
                    variant="text"
                    className="flex items-center gap-2 max-h-[20px]"
                    onClick={() => {if(setIndex && currentPage) setIndex(currentPage - 1)}}
                    disabled={currentPage === 0 || loading || !totalElements}
                >
                    <ChevronLeft strokeWidth={2} className="h-4 w-4"/> {t('previous')}
                </Button>
                <ButtonsPagination {...{
                    loading,
                    pageLimit,
                    end,
                    start,
                    currentPage,
                    totalElements,
                    setIndex}}/>
                <Button
                    placeholder='button'
                    variant="text"
                    className="flex items-center gap-2 max-h-[20px]"
                    onClick={() => {if(setIndex && currentPage !== undefined) setIndex(currentPage + 1)}}
                    disabled={(getCurrent() >= (totalPages! - 1)) || loading || !totalElements}
                >
                    {t('next')}
                    <ChevronRight strokeWidth={2} className="h-4 w-4"/>
                </Button>
            </div>
        </CardFooter>
    );
}
